var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-card",class:{
  'check-card--checked': _vm.checked,
  'check-card--multi': _vm.multi,
},on:{"click":_vm.onClick}},[_vm._t("default"),_vm._m(0),(_vm.count != null)?_c('div',{staticClass:"check-card__count"},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-card__checkbox"},[_c('i',{staticClass:"el-icon-check"})])}]

export { render, staticRenderFns }